<template>
  <div style="min-height: 500px;">
    <div class="waterfull2 d-flex" style="margin-bottom: 14px;" v-if="!boardDetailShow">
      <div style="flex: 1;" class="el-radio-group-cont">
        <div class="el-select-dropdown _select_box" style="width: 200px;color: #9A9AB7;">
          排序：
          <el-select
            v-model="orderType"
            placeholder="请选择"
            size="small"
            style="width: 85px;color: #9A9AB7;"
            @change="boardTypeChange"
          >
            <el-option
              v-for="dict in cnl_data"
              :key="dict.value"
              :label="dict.label"
              :value="dict.value"
            />
          </el-select>
        </div>
      </div>
    </div>

    <div class="d-flex" style="flex-wrap: wrap;width: 100%;position: relative;">
      <div class="cell-item add-item" 
        style="z-index: 20;position: relative;"
        :style="{  width: ( itemWidth )+ 'px' , height: ( itemWidth )+ 'px' }" @click="creatBoard" v-if="page_user && ac_data && (page_user == ac_data.uid) && !boardDetailShow">
        <el-image style="width: 20px; height: 20px;margin-bottom: 8px;" 
          :src="require('../assets/img/DrawingBoard/add.png')"
            fit="contain">
          <div slot="placeholder" class="image-slot"></div>
        </el-image>
        创建画板
      </div>
      <template v-if="folderPageData.length > 0 && !boardDetailShow">
        <div class="cell-item board-item" 
          :class="{ 'board-item-nocover': !item.cover }"
          style="background-size: cover;background-position: center;z-index: 20"
          :style="{  width: ( itemWidth )+ 'px' , height: ( itemWidth )+ 'px' , 'background-image': `url( ${ item.cover ? item.cover : 'none'  } )`}" 
          v-for="(item, index) in folderPageData" v-on:mouseover="handleMouseOver(index)" v-on:mouseout="handleMouseOut(index)"
          @click="boardDetailClick( item , index )"
          >          
          <div class="edit" @click.stop="edit_click(item , index )" v-if="page_user && ac_data && (page_user == ac_data.uid)" style="z-index: 100">
            <el-image style="width: 16px; height: 16px;" 
              :src="require('../assets/img/DrawingBoard/edit.png')"
                fit="contain" class="edit_image">
              <div slot="placeholder" class="image-slot"></div>
            </el-image>
          </div>

          <div v-if="!item.cover" style="height: 100%;width: 100%;position: absolute;left: 0;top:0;right: 0;bottom: 0;justify-content: center;align-items: center;font-size: 14px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #49495A;" class="d-flex">
            此画板内暂无作品
          </div>
          <div class="botton_cont d-flex">
            <div style="flex:1;position: relative;box-sizing: border-box;align-items: center;" class="uname d-flex">
              <div :style="{  maxWidth: (itemWidth-100)+ 'px' }"
              style="overflow: hidden; white-space: nowrap;text-overflow: ellipsis;color:#fff"
              >
                {{ item.name }}
              </div>
              <el-image style="width: 26px; height: 14px;margin-right: 2px;margin-left: 2px;" 
                :src="require('../assets/img/waterfall/vip.png')"
                  fit="contain" v-if="item.ownerIsVip">
                <div slot="placeholder" class="image-slot"></div>
              </el-image>
            </div>
            
            <el-image style="width: 18px; height: 18px;margin-right: 2px" 
              :src="require('../assets/img/DrawingBoard/board.png')"
                fit="contain">
              <div slot="placeholder" class="image-slot"></div>
            </el-image>

            <div style="color:#fff">{{ item.paintingNums ? item.paintingNums : 0 }}</div>
          </div>
        </div>
      </template>
      <template v-if="folderPageData.length > 0 && boardDetailShow">
        <div style="width: 100%;align-items: center;" class="d-flex">
          <el-image style="height: 20px;width: 20px;margin-right: 4px;cursor: pointer;" :src="require('../assets/img/explore/back.png')" @click="closeBoard">
            <div slot="placeholder" class="image-slot"></div>
          </el-image>
          <span style="font-size: 17px;font-weight: 500;color: #FFFFFF;">
            {{ boardName }}
          </span>
          <span style="margin-left: 6px;height: 15px;background: rgba(0,111,255,0.2);border-radius: 2px;font-size: 12px;color: #006FFF;padding: 3px;justify-content: center;align-items: center;" class="d-flex">
            {{ boardNum }}
          </span>
        </div>
        <PersonalWaterfall :borderId="borderId" @loginFormShowChange="loginFormShowChange" v-if="folderPageData.length > 0 && boardDetailShow" :ac_data="ac_data"></PersonalWaterfall>
      </template>


      <div style="position: absolute;left: 0; right: 0; height: 300px;z-index: 0;justify-content: center;" class="d-flex" v-if="folderPageData.length == 0 ">
        <div class="empty d-flex" style="position: relative;text-align: center;color: #49495A;z-index: 2;flex-direction: column;justify-content: flex-start;align-items: center;"
          :style="{ width: 300 + 'px' , height: 300 + 'px' }"
          
        >
          <el-image :style="{ height: ( 200 ) + 'px' , width: ( 200  ) + 'px'  }"
            :src="require('../assets/img/DrawingBoard/empty.png')"
              fit="contain">
            <div slot="placeholder" class="image-slot"></div>
          </el-image>
          <div style="position: relative;z-index: 2;width: 100%;height: 30px;">暂无画板</div>
        </div>
      </div>
    </div>

    <Confirm4 :dialogComfirm4Visible.sync="confirm4Visible" v-if="confirm4Visible"  @confirm4Submit="confirm4Submit"></Confirm4>
    <Confirm5 :dialogComfirm5Visible.sync="confirm5Visible" v-if="confirm5Visible"  @confirm5Submit="confirm5Submit" :boardName="boardName" @confirm5DeleteShow="confirm5DeleteShow"></Confirm5>
    <ConfirmDel5 :dialogConfirmDel5Visible.sync="confirm5DelVisible" v-if="confirm5DelVisible" @confirm5Del="confirm5Del" ></ConfirmDel5>
    <LoginForm :dialogLoginVisible.sync="loginFormShow" v-if="loginFormShow"></LoginForm>
  </div>
</template>

<script>
import common from '../utils/common'
import {  square_page_req , like_edit_req , square_detail } from "@/api/square";
import { painting_page_req , painting_publish_req  ,  painting_cancel_req , painting_remove_req  , folder_edit_req , painting_move_req , folder_page_req ,folder_remove_req} from "@/api/personal";
import Confirm4 from "@/components/personal/Confirm4" 
import Confirm5 from "@/components/personal/Confirm5" 
import ConfirmDel5 from "@/components/personal/ConfirmDel5"
import PersonalWaterfall from "@/components/PersonalWaterfall" ;


export default {
  props: {
    //model 
    model : {
      type: String,
      default: '',
    },
    ac_data : {
      type : Object , 
      default : {}
    }
  },  
  components:{
    Confirm4 ,
    Confirm5 , 
    ConfirmDel5 , 
    PersonalWaterfall
  } ,
  name : "DrawingBoard" ,
  data () {
    return {
      page_user : undefined , 
      isPublic : false ,
      imgList : [] , 
      pageNum : 1 ,
      pageSize : 30 , 
      isHover : false , 
      isHoverBtn : false ,  
      hoverIdx : undefined , 
      columnType : localStorage.getItem("columnType") ? localStorage.getItem("columnType") : 2 ,  //分几列
      orderType : 3  , //1:最新2：最热
      type1 : "最新生成" , //1:最新2：最热
      show : false  , 
      itemWidth : 100 , 
      last_id : undefined , //之前的id ，
      lastWidth : undefined , //之前的宽度
      borderId : undefined , //画板id
      boardDetailShow : false  , //显示画板详情
      loginFormShow : false , 

      cnl_data : [{
        label : "最新更新" , 
        value : 3
      },{
        label : "时间升序" , 
        value : 1      
      },{
        label : "时间降序" , 
        value : 2      
      }] ,
      folderPageData : [] , 
      confirm4Visible : false , 
      confirm5Visible : false , 
      confirm5DelVisible : false , 

      boardName : undefined ,
      boardNum : undefined , 
      boardId : undefined , 
      boardIndex : undefined , 
    }
  },
  computed:{
    // itemWidth(){  
    //   return (( (document.documentElement.clientWidth - 168)  / 7 ) ) - 15
    // } ,
    tokenVuex() {
      // 存储位置： store.state.{模块名,在store/index.js中module下的}.{state中定义的属性}
      return this.$store.state.user.token
    } ,
    columnNum(){
      let _num  = 4 ;
      if( this.columnType == 1 ){
        _num = 4 ; 
      } else if( this.columnType == 2 ){
        _num = 6 ; 
      } else if( this.columnType == 3 ){
        _num = 7 ; 
      }
      return _num ; 
    } ,
  },
  mounted () {
    this.page_user = this.$route.query.user  ;
    // this.get_square_page( );
    this.itemWidth = (( (document.documentElement.clientWidth - 168)  / this.columnNum ) ) - 15 ;  ; 
    window.addEventListener('resize', this.resize, false )
    // this.get_img_list()
    this.folder_page();
  },
  // 注销 window.onresize
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
  },
  methods:{
    loginFormShowChange(data) {
      this.loginFormShow = data;
    } ,
    get_square_page(){
      this.loading = true ; 
      square_page_req({
        pageNum : this.pageNum  ,
        pageSize : this.pageSize , 
        type : this.type  ,
        model : this.model ? this.model : undefined
      }).then( res => {
        this.imgList = this.imgList.concat( res.data.records ) ;
        this.loading = false  ; 
      }).catch().finally( ()=>{
        this.loading = false ; 
      })
    },
    loadwatermore(){
      this.pageNum++ ;
      this.get_square_page();
    } ,

    handleMouseOver( index ) {
      this.isHover = true;
      this.hoverIdx = index ; 
    },
    handleMouseOverBtn( index ){
      this.isHoverBtn = true;
      this.hoverIdx = index ; 
    },
    handleMouseOut( ) {
      this.isHover = false ;
      this.hoverIdx = undefined ; 
    },
    handleMouseOutBtn(){
      this.isHoverBtn = false ;
      this.hoverIdx = undefined ; 
    },
    resize() {
      this.folderPageData = [] ;
      this.pageNum = 1 ;
      // this.get_square_page( );  
      this.folder_page()
      // this.$waterfall.forceUpdate()   //forceUpdate
      this.show = false ;
      setTimeout(  ()=>{
        this.itemWidth = (( (document.documentElement.clientWidth - 168)  / this.columnNum ) ) - 15 ; 
        this.show = true ;
      } , 30)
    },
    folder_page(){
      folder_page_req({
        pageSize : 99999 ,
        pageNum : 1 , 
        orderType : this.orderType , 
        uid : this.page_user == this.ac_data.uid ? undefined :  this.page_user 
      }).then( res => {
        this.folderPageData = res.data.records ? res.data.records  : [ ]
      })
    },
    boardTypeChange(){
      this.resize();
    } ,
    creatBoard(){
      this.confirm4Visible = true  ; 
    } , 
    confirm4Submit( name ){
      this.confirm4Visible = false ;
      folder_edit_req({
        name : name , 
        remark : undefined,
        uid: this.ac_data.uid ,
      }).then( res => {
        if( res.success ){
          this.$toast.open({ message: '操作成功', position: 'top', duration: 3000, type: 'success' });
          this.resize();
        }
      })
    } ,
    confirm5Submit( name ){
      folder_edit_req({
        id :  this.boardId ,
        name : name , 
        remark : undefined,
        uid: this.ac_data.uid ,
      }).then( res => {
        if( res.success ){
          this.$toast.open({ message: '操作成功', position: 'top', duration: 3000, type: 'success' });
          this.folderPageData[ this.boardIndex ].name = name ;
        }
      })
    } ,
    confirm5DeleteShow(){
      this.$nextTick(() => {
        this.confirm5DelVisible = true ;
      });
    },
    confirm5Del( flag ){
      console.log( flag )
      console.log( this.boardId )
      folder_remove_req({
        id : this.boardId , 
        incloudChildren : !flag 
      }).then( res => {
        this.resize();
      })
    },
    edit_click(item , index ){
      this.boardId = item.id ;
      this.boardName = item.name ;
      this.boardIndex = index ;
      this.confirm5Visible = true  ; 
    },
    boardDetailClick( item , index ){
      if( !item.paintingNums ) return ;
      this.boardName = item.name ;
      this.boardNum = item.paintingNums ; 
      this.borderId = item.id ; 
      this.boardDetailShow = true ;
    } ,
    closeBoard(){
      this.boardDetailShow = false;
      this.resize()
    }
  },
  activated(){
    if(  this._user  && (this._user !=   this.$route.query.user) ){
      this.page_user = this.$route.query.user
      this.folder_page();
    }
  }, 
  deactivated(){
    this._user =  this.page_user  ;
  },  
  watch: {
    $route(){
      this.page_user = this.$route.query.user
    },
    page_user(){
      this.folder_page();
    }
  }


}

</script>

<style lang="scss" scoped>


::v-deep .form-control {
  border: none;
}
::v-deep .form-control:focus {
  border-color: #fff;
  box-shadow : none
}
::v-deep .waterfull ._laebl {
  margin-bottom: 0;
}
::v-deep  .waterfull {
  .el-radio-group {
    background-color: #222337;
    border-radius: 20px;
  }
  .el-radio-button .el-radio-button__inner {
    border-radius: 20px ;
    background-color: #222337;
    border: 1px solid #222337;
    color: #fff;
  }  
  .is-active .el-radio-button__inner {
    background-color: #006FFF;
  }
}




.cont {
  padding: 60px 84px 0;
  // height: calc(100% );
  box-sizing: border-box;
}
.row {
  margin-left: 0;
  margin-right: 0;
}

.icon {
  width: 40%;
  min-width: 70px;
  min-height: 70px;
  padding-bottom: 40%;
  margin: 0 auto;
}


.home1 {
  margin-top: 77px;
  justify-content: center;
  align-items: center;
  font-size: 32px;
  color: #fff;
} 

.home2 {
  margin-top: 42px;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;

  .item {
    box-sizing: border-box;
    height: 40px;
    width: 96px;
    border-radius: 20px;
    text-align: center;
    line-height: 40px;
  }
  .active {
    background-color: #fff;
    color : #fff ;
    font-weight: 500;
    height: 40px;
    width: 96px;
    background: #222337;
    border-radius: 20px;
    text-align: center;
    line-height: 40px;
    margin-right: 102px;
  }
}

.home3 {
  width: 1000px;
  justify-content: center;
  align-items: center;
  color: #fff;
  height: 66px;
  border-radius: 33px;
  background-color: #222337;
  margin: 24px auto 20px ;
  .l {
    justify-content: center;
    align-items: center;
    width: 72px;
    height: 66px;
  }
  .input {
    background-color: #222337;
    color: #fff;
    padding: 0;
  }
  .input::placeholder {
    color: #49495A;
  }


  .search-btn {
    height: 66px;
    width: 92px;
    align-items: center;
    justify-content: center;
  }
}

.waterfall_title {
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 33px;
  margin-top: 43px;
  margin-bottom: 16px;
}
.cell-item {
  overflow: hidden;
  border-radius: 10px;
  margin-bottom: 14px;
  position: relative;
  margin-right: 15px;
  .edit { 
    display: none
  }
  .btn {
    display: block;
    position: absolute;
    top: 8px;
    right: 8px;
    width: 66px;
    height: 34px;
    line-height: 34px;
    background: rgba(0,0,0,0.6);;
    border-radius: 17px;
    text-align: center;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    padding: 0;
  }
  .botton_cont {
    position: absolute;
    padding-bottom: 8px;
    padding-left: 8px;
    padding-right: 8px;
    height: 30px;
    bottom: 0;
    left: 0;
    right: 0;
    align-items: center;
    font-size: 14px;
    background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.8) 100%);
    .uname {
      overflow: hidden;//多出部分隐藏
      white-space: nowrap;//一行显示
      text-overflow: ellipsis;//是否显示省略号
      padding-right: 5px;
    }
  }
}
.cell-item:nth-child(7n) {
  margin-right: 0;
}

.cell-item.add-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #0B0B1F;
  border-radius: 10px;
  border: 2px dashed #9A9AB7;
  box-sizing: border-box;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #9A9AB7;
  cursor: pointer;
}
.cell-item.board-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #0B0B1F;
  border-radius: 10px;
  box-sizing: border-box;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #9A9AB7;
  background: #1B1D2E;
}



.cell-item:hover img {
    transform: scale(1.15);
    transition : all 0.5s ;
} 
.cell-item {
  .btn:hover {
    display: block;
    position: absolute;
    top: 8px;
    right: 8px;
    width: 66px;
    height: 34px;
    line-height: 34px;
    background: #006FFF;
    border-radius: 17px;
    text-align: center;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    padding: 0;
  }
}

.cell-item:hover {
  .edit { 
    display: flex;
    position: absolute;
    top: 8px;
    right: 8px;
    width: 28px;
    height: 28px;
    background: rgba(0,0,0,0.6);
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    .edit_image {
      height: 16px;
      width: 16px;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>